
export function openHtmlAsPdfPreview({ html, title }) {
  const win = window.open();
  if (!win) return;

  const { styles, metas, body } = extractHtmlAssets(html);

  win.document.open();
  win.document.write(`
    <!DOCTYPE html>
    <html lang="pt-BR">
      <head>
        ${metas.join("\n")}
        <title>${title ?? ""}</title>

        <!-- Style base -->
        <style>
          /* ===== FOLHA A4 ===== */
          body > * {
            background: #fff;
            width: 210mm;
            min-height: 297mm;
            margin: 0 auto;
            padding: 20mm;
            box-shadow: 0 0 18px rgba(0,0,0,0.25);
          }

          p {
            line-height: 1.5;
            margin-bottom: 8px;
          }

          @media print {
            body {
              background: none;
              padding: 0;
            }

            body > * {
              width: auto;
              min-height: auto;
              margin: 0;
              padding: 0;
              box-shadow: none;
            }
          }
        </style>

        <!-- Styles vindos do conteúdo -->
        ${styles.map(css => `<style>${css}</style>`).join("\n")}
      </head>
      <body>
        <main>
          ${body}
        </main>
      </body>
    </html>
  `);

  win.document.close();

  return win;
}

function extractHtmlAssets(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const styles = [...doc.querySelectorAll("style")].map(
    style => style.innerHTML
  );

  const metas = [...doc.querySelectorAll("meta")].map(
    meta => meta.outerHTML
  );

  // remove do body
  doc.querySelectorAll("style, meta").forEach(el => el.remove());

  return {
    styles,
    metas,
    body: doc.body.innerHTML
  };
}


